export default function Services() {
  const services = [
    {
      title: 'Market Entry Strategy',
      description: 'Comprehensive market analysis and entry planning to ensure successful launches in new territories.',
      points: [
        'Market research and competitive analysis',
        'Regulatory compliance guidance',
        'Local partnership development',
        'Go-to-market strategy development'
      ],
      image: 'https://public.readdy.ai/ai/img_res/a39beb0f7e518c7aa1fb9bec93b6d5ec.jpg',
      gradient: 'from-teal-500 to-emerald-500'
    },
    {
      title: 'Channel Partner Development',
      description: 'Building and managing robust partner networks to maximize your market reach and revenue potential.',
      points: [
        'Partner recruitment and onboarding',
        'Training and enablement programs',
        'Performance tracking and optimization',
        'Incentive program management'
      ],
      image: 'https://readdy.ai/api/search-image?query=Business%20handshake%20and%20partnership%20collaboration%20in%20modern%20tech%20company%2C%20professional%20networking%20event%20with%20technology%20vendors%2C%20contemporary%20office%20space%20with%20emerald%20green%20accents%2C%20corporate%20partnership%20atmosphere%20with%20digital%20displays&width=800&height=600&seq=service-002&orientation=landscape',
      gradient: 'from-emerald-500 to-green-500'
    },
    {
      title: 'Marketing & Brand Positioning',
      description: 'Strategic marketing campaigns that elevate your brand and drive demand in target markets.',
      points: [
        'Brand strategy and positioning',
        'Digital marketing campaigns',
        'Content creation and distribution',
        'Lead generation and nurturing'
      ],
      image: 'https://readdy.ai/api/search-image?query=Creative%20marketing%20team%20working%20on%20digital%20campaigns%20with%20multiple%20screens%20showing%20brand%20designs%2C%20modern%20creative%20workspace%20with%20technology%20tools%2C%20vibrant%20green%20and%20teal%20color%20scheme%2C%20professional%20marketing%20environment%20with%20collaborative%20energy&width=800&height=600&seq=service-003&orientation=landscape',
      gradient: 'from-green-500 to-teal-500'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 max-w-xl">
            Comprehensive Technology Marketing Services
          </h2>
          <p className="text-lg text-gray-600 max-w-xl">
            End-to-end solutions designed to accelerate your market presence and drive sustainable growth across global markets.
          </p>
        </div>

        <div className="h-px bg-gradient-to-r from-teal-500 via-emerald-500 to-green-500 mb-16"></div>

        <div className="space-y-24">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid md:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                <div className="w-full h-96 rounded-2xl overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className={`${index % 2 === 1 ? 'md:order-1' : ''}`}>
                <div className={`border-l-4 border-gradient-to-b ${service.gradient} pl-6`}>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                  <ul className="space-y-3 mb-6">
                    {service.points.map((point, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <div className={`w-6 h-6 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                          <i className="ri-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-gray-700">{point}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href="#contact"
                    className={`inline-flex items-center gap-2 text-sm font-semibold bg-gradient-to-r ${service.gradient} bg-clip-text text-transparent hover:gap-3 transition-all cursor-pointer`}
                  >
                    Learn More
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
